import {
  ActionIcon,
  Group,
  MultiSelect,
  MultiSelectProps,
  Select,
  SelectProps,
  Tooltip,
} from '@mantine/core';
import { IconRefresh } from '@tabler/icons-react';

import { useGetManyPathologiesQuery } from '@api/pathologies.api';

type PathologiesSelectorProps =
  | (Omit<
      SelectProps,
      'data' | 'searchable' | 'nothingFoundMessage' | 'placeholder'
    > & {
      multiple?: false;
    })
  | (Omit<
      MultiSelectProps,
      'data' | 'searchable' | 'nothingFoundMessage' | 'placeholder'
    > & {
      multiple: true;
    });

export default function PathologiesSelector(props: PathologiesSelectorProps) {
  // ==========================================================================
  // Api
  // ==========================================================================
  const {
    data = [],
    isLoading,
    refetch,
  } = useGetManyPathologiesQuery({
    sortBy: 'name',
    sortOrder: 'asc',
  });

  // ==========================================================================
  // Render
  // ==========================================================================
  return props.multiple ? (
    <MultiSelect
      {...props}
      label={
        <Group
          display="inline-flex"
          w="max-content"
          gap="0.2rem"
          align="center"
        >
          <Tooltip label="Ricarica opzioni">
            <ActionIcon size="1rem" variant="subtle" onClick={refetch}>
              <IconRefresh />
            </ActionIcon>
          </Tooltip>
          <span>{props.label}</span>
        </Group>
      }
      searchable
      nothingFoundMessage="Nessuna patologia trovata"
      placeholder={
        props.value?.length || 0 > 0 ? undefined : 'Seleziona le patologie'
      }
      data={data.map((pathology) => ({
        value: pathology.id,
        label: pathology.name,
      }))}
      disabled={isLoading || props.disabled}
    />
  ) : (
    <Select
      {...props}
      label={
        <Group
          display="inline-flex"
          w="max-content"
          gap="0.2rem"
          align="center"
        >
          <Tooltip label="Ricarica opzioni">
            <ActionIcon size="1rem" variant="subtle" onClick={refetch}>
              <IconRefresh />
            </ActionIcon>
          </Tooltip>
          <span>{props.label}</span>
        </Group>
      }
      searchable
      nothingFoundMessage="Nessuna patologia trovata"
      placeholder="Seleziona la patologia"
      data={data.map((pathology) => ({
        value: pathology.id,
        label: pathology.name,
      }))}
      disabled={isLoading || props.disabled}
    />
  );
}
